import { render, staticRenderFns } from "./qyxx.vue?vue&type=template&id=a4076190&scoped=true&"
import script from "./qyxx.vue?vue&type=script&lang=js&"
export * from "./qyxx.vue?vue&type=script&lang=js&"
import style0 from "./qyxx.vue?vue&type=style&index=0&id=a4076190&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4076190",
  null
  
)

export default component.exports